import mockTutor from './tutor';
import { initMock, passThroughOtherCalls } from './mock';

const mockApi = () => {
  initMock();
  mockTutor();
  passThroughOtherCalls();
};

export default mockApi;



// WEBPACK FOOTER //
// ./src/mock/index.js